/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for ExtensionEtablissementResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { ExtensionEtablissementListDTO, RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class ExtensionEtablissementResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addorUpdateExtensionEtablissement(extensionEtablissementListDTO: ExtensionEtablissementListDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    addorUpdateExtensionEtablissement(extensionEtablissementListDTO: ExtensionEtablissementListDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    addorUpdateExtensionEtablissement(extensionEtablissementListDTO: ExtensionEtablissementListDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    addorUpdateExtensionEtablissement(extensionEtablissementListDTO: ExtensionEtablissementListDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/addorUpdateExtensionEtablissement`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: extensionEtablissementListDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement1(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement1(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement1(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement1(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement2(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement2(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement2(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement2(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement4(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement4(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement4(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement4(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement3(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement3(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement3(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement3(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement6(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement6(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement6(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement6(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    supprimerExtensionEtablissement5(idExtensionEtablissement: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    supprimerExtensionEtablissement5(idExtensionEtablissement: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    supprimerExtensionEtablissement5(idExtensionEtablissement: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    supprimerExtensionEtablissement5(idExtensionEtablissement: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/supprimer-extension-etablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement1(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement1(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement1(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement1(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement2(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement2(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement2(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement2(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement4(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement4(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement4(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement4(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement3(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement3(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement3(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement3(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement6(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement6(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement6(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement6(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionByEtablissement5(idEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<ExtensionEtablissementListDTO>>;
    getExtensionByEtablissement5(idEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement5(idEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<ExtensionEtablissementListDTO>>>;
    getExtensionByEtablissement5(idEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-extensions-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById1(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById1(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById1(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById1(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById2(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById2(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById2(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById2(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById4(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById4(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById4(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById4(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById3(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById3(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById3(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById3(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById6(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById6(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById6(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById6(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtensionEtablissementById5(idExtensionEtablissement?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<ExtensionEtablissementListDTO>;
    getExtensionEtablissementById5(idExtensionEtablissement?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById5(idExtensionEtablissement?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<ExtensionEtablissementListDTO>>;
    getExtensionEtablissementById5(idExtensionEtablissement?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/extensionEtablissement`;

        let params = new HttpParams();
        if (idExtensionEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idExtensionEtablissement, 'idExtensionEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
